import React ,{Component} from 'react'; 
import { Navigate  } from 'react-router-dom';
import axios from 'axios';
import Serverurl from './Apiurl';
import Button from '@mui/material/Button';
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import AddBoxRoundedIcon from '@mui/icons-material/AddBoxRounded';
import FormControl from '@mui/material/FormControl';
import Collapse from '@mui/material/Collapse';
import CloseIcon from '@mui/icons-material/Close';
import TextField from '@mui/material/TextField';
import IconButton from '@mui/material/IconButton';
import Alert from '@mui/material/Alert';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import { styled } from '@mui/material/styles';

import NativeSelect from '@mui/material/NativeSelect';





  const VisuallyHiddenInput = styled('input')({
  clip: 'rect(0 0 0 0)',
  clipPath: 'inset(50%)',
  height: 1,
  overflow: 'hidden',
  position: 'absolute',
  bottom: 0,
  left: 0,
  whiteSpace: 'nowrap',
  width: 1,
});


 export default class Cms extends Component {

   constructor(props) {
      super(props);
	  
      this.state = {
		  
		
		  open:false,preveicon:'',preview:'',
		  isdisplay:true,isfiledisplay:false, isdashboard:false,iscontent:false,page_title:'',
		   redirect:false,name:'',cm_id :'',cm_pagetitle:'',alerttype:"error",cm_title:'',cm_content:'',cm_youtubevediolink:'',
      errormessage:'',erropen:false,btndisabled:false,cmstitledata:[],
submitbtn:"Save",PagetitleArray:[],cmsData:[],brid:'',Branchdata: [],
	  }
   }
      
   
   myChangeHandler = (event) => {
  let nam = event.target.name;
  let val = event.target.value;
  this.setState({[nam]: val}); 
} 
	  
	  
	 
handleErrorclose=(event)=>{
	  
	this.setState({erropen: false});  
  }
  

   	  
handleSubmit= (event) => {
	let page_title=this.state.page_title;   
 let cm_pagetitle = this.state.cm_pagetitle;
 let cm_title = this.state.cm_title;
 let cm_content = this.state.cm_content;
  let cm_youtubevediolink = this.state.cm_youtubevediolink;
let preveicon = this.state.preveicon;
//let brid = this.state.brid;
if(page_title==="" || page_title==="0")
{
	
	this.setState({errormessage:"Please Select Page",erropen:true});
		 window.scrollTo({
          top: 0
      })
		 return false;
	
	
}
if(this.state.cm_id==="2")
{




if(cm_title==="")
{
	
	this.setState({errormessage:"Please Enter Title",erropen:true});
		 window.scrollTo({
          top: 0
      })
		 return false;
	
	
}
if(cm_youtubevediolink==="")
{
	
	this.setState({errormessage:"Please Enter Youtube Vediolink ",erropen:true});
		 window.scrollTo({
          top: 0
      })
		 return false;
	
	
}
if(cm_content==="")
{
	
	this.setState({errormessage:"Please Enter Content ",erropen:true});
		 window.scrollTo({
          top: 0
      })
		 return false;
	
	
}


}
if (this.state.cm_id === "3" && (!this.state.brid || this.state.brid === "0")) {
  this.setState({
    errormessage: "Please select a Branch",
    erropen: true
  });
  window.scrollTo({ top: 0 });
  return false;
}





	 var formData = new FormData();

	  
	   formData.append('cm_id',this.state.cm_id)
		formData.append('action','update') 
		
		formData.append('cm_pagetitle',cm_pagetitle)
		formData.append('cm_title',cm_title)
		formData.append('cm_youtubevediolink',cm_youtubevediolink)
		
		
		if(this.state.cm_id==3)
			{
if(cm_content!=="")
	  {
		
		for (const key of Object.keys(this.state.cm_content)) {
            formData.append('Filedata', this.state.cm_content[key])
        }
 	
	   formData.append('cm_content','1')		
	  }else
	  {
		 formData.append('cm_content',this.state.cm_content)	  
	  
	  }
			}else
			{
				
					formData.append('cm_content',cm_content)
	
				
			}
		
		formData.append('userid',localStorage.getItem("AYLuserid"))
		formData.append('cm_brid', this.state.brid);
		
	console.log([...formData.entries()]);  
 axios.post(Serverurl+"ajaxcms.php", formData, {
        }).then(res => {
				if(res.data!=-1)
					{
						
					let strreturn=res.data;
					strreturn=strreturn;
					
				
					this.setState({cm_title:"",cm_pagetitle:"",cm_id:'',page_title:'',cm_content:"",cm_youtubevediolink:"",errormessage:"Content Updated Successfully",erropen:true,alerttype:"success",preveicon:'',preview:''});
		 window.scrollTo({
          top: 0
      })
				
						//this.setState({redirect:true,pagename:'/Promotion'});
					
					//this.setState({open:false,btnsavedisbaled:false,btnsavetxt:'Save',});
				
						
							
							
						}
	   });
	  
    				
					
				}
  
		componentDidMount() {
			document.title = "AthaYog Living -  Manage Content";
	
	if(localStorage.getItem("AYLuserid")==null)
		  {

		   this.setState({
            redirect: true,
			pagename:'/Default'
          })
		  }
  this.CmsPageTitleBind();

		}			
  
  
	
	  CmsPageTitleBind(){

    axios.get(Serverurl+'ajaxcms.php?action=getall')
	
    
      .then((resp) => {    
     

	  
	  
	  let cmsApi = resp.data.map(row => {
                      
          return {value: row.cm_id, display:row.cm_pagetitle}
        });
		
		 this.setState({
          cmsData: [{value: '0', display:'Page Title'}].concat(cmsApi)
        },()=>{console.log(this.state.cmsData)});
      }).then(data => {
		 
    
      }) 

}  
	








	







	
	  apicall()
	{
		var self=this;
	
		  axios.get(Serverurl+'ajaxcms.php?action=getall&cm_id='+this.state.page_title)

		    .then((response) => {    

   this.setState({ 
     
      cm_id:response.data[0].cm_id,
	  cm_pagetitle: response.data[0].cm_pagetitle,
      cm_title: response.data[0].cm_title,
cm_content: response.data[0].cm_content,	  
cm_youtubevediolink: response.data[0].cm_youtubevediolink,    
  preveicon:response.data[0].cm_content,  
  preview:response.data[0].cm_content,  
    }); 
	 
	 
	    }) 
 
	  
	}
	  

	  


  onchangeHandler = (event) => {
    let nam = event.target.name;
    let val = event.target.value;

    this.setState({ [nam]: val }, () => {
      this.apicall();
      if (val == 1  ) {
		
        this.setState({ isdisplay:true,isfiledisplay:false,isdashboard:false,iscontent:false,isbranch: false });
      } 
	 else  if ( val == 2 || val == 6 || val == 7 || val == 8 || val == 9 || val == 10 || val == 11 || val == 12) {
		
        this.setState({ isdisplay:true,isfiledisplay:false ,isdashboard:false,iscontent:true,isbranch: false});
      }
	  else if (val == 4 || val == 5 ) {
        this.setState({ isdashboard:true,isfiledisplay:true,isdisplay:false, iscontent:false,isbranch: false });
      }
	  else if (val == 3) {
  this.setState({
    isdashboard: false,
    isfiledisplay: true,
    isdisplay: false,
    iscontent: false,
    isbranch: true
  }, () => {
    this.onloadBranch(); 
  });
}
	  else{
		    this.setState({ isdisplay:false,isfiledisplay:true,isdashboard:false,iscontent:false,isbranch: false });
		  
	  }
    });
  };
  
  
  
  
  
	onaddFileChange=(e) =>{   
	
	   let imageFile = e.target.files[0];
	//alert(imageFile.name);
  if (!imageFile.name.match(/\.(png|jpeg|jpg|doc|pdf)$/)) {

   this.setState({errormessage:"Please Upload File (png, jpeg, jpg, doc, pdf).",open:true,erropen:true,alerttype:"error"});
		 window.scrollTo({     top: 0     })
	
  
    return false;
  }else{
        this.setState({ cm_content: e.target.files })
  }
  
		
    }
  
onloadBranch()
{
	axios.post(Serverurl+'ajaxbranch.php?action=getall')
  .then(resp => {  
		
  if(resp.data.length>0){
	  this.setState({Branchdata:resp.data,},()=>{
								let strbrid=this.state.brid;

								if(resp.data.length===1 && strbrid!='')
								{
									strbrid=resp.data[0]["bm_id"];
								}
								 let BranchFromApi = this.state.Branchdata.map(row => {
                          
          return {value:row.bm_id,display:row.bm_name}
        });
      
		
        this.setState({brid:strbrid,
          Branchdata: [{value: '0', display:'Select Branch'}].concat(BranchFromApi)
        },()=>{
			if( this.state.classtype==="3" || this.state.classtype==="4" || this.state.classtype==="7")
							{
					
//this.onloadslot();	
							}
			
			
		});
								
							})


							
  }else{
	  this.setState({Branchdata:[]});
  }
  });
	
}  
  
  
  
  
  
  
  
	  
render() { 
  
  if (this.state.redirect === true) {
      return <Navigate to={this.state.pagename} />
    }
  
 
  
  return (
  

		<React.Fragment>

<div className="mainheading"><h1> Manage Content</h1></div>

<div className="clear"></div>


  <p>   <Collapse in={this.state.erropen}>
        <Alert
          action={
            <IconButton
              aria-label="close"
              color="inherit"
              size="small"
              onClick={() => {
               this.handleErrorclose();
              }}
            >
              <CloseIcon fontSize="inherit" />
            </IconButton>
          } severity={this.state.alerttype}
        >
        {this.state.errormessage}
        </Alert>
      </Collapse></p>
    
 
	
<div className="formmain">

<ul>





 <li>
		  <p>Page Title</p>
		  <p><FormControl  className="stadrp">
         
        <Select
         native  fullWidth		 
		 variant="outlined"
            margin="normal"
		 value= {this.state.page_title}
          onChange={this.onchangeHandler}
		  		 inputProps={{tabIndex: "1",}} className="txtbox"
          id="page_title"
		   value={this.state.page_title}
		  name="page_title"
		
		
        >
		{this.state.cmsData.map(br => (
            <option  
            
              value={br.value}
            >
              {br.display}
            </option  >
          ))}
		
        </Select></FormControl>
		</p>
		  </li>


		  {this.state.isfiledisplay==true && (
		  
	 <li>
		  <p>File Upload: Please upload file of size less than or equal to <b>1 MB</b></p>
		   
		  <p> 
	       <Button component="label"  className="iconuploadbtn"  onChange={this.onaddFileChange}   variant="contained"   accept="image/*;capture=camera" startIcon={<CloudUploadIcon />}>
	      Upload File
		  <VisuallyHiddenInput type="file"   /></Button>
		   &nbsp; {this.state.preview!=="" && (
		<a href={Serverurl+'uploads/'+this.state.preview} target="blank">View</a>
		)}
		  </p>
		 
		  </li>
		
		
		
		
		  
		  )} 

		  {this.state.isbranch==true && (
		  
	 <li>
		  <p>Select Branch</p>

<p>
<FormControl  >			   
			<Select
			 className="txtbox"
			native
			value={this.state.brid}
			onChange={this.myChangeHandler}
			name='brid'
			
			fullwidth
			
			
			>
		
		
			{this.state.Branchdata.map(row => (
				<option  
            
				  value={row.value}
				>
				  {row.display}
				</option  >
			  ))}
			 </Select>
		</FormControl>
</p>
		 
		  </li>
		
		
		
		
		  
		  )}
		  
		 


{this.state.isdashboard===true && ( 

<li>  
		 <p><span className="validation">*</span> Title</p>
		 
		<p>
		<TextField name="cm_title" 
	   onChange={this.myChangeHandler} 
	   fullWidth 		 	 inputProps={{tabIndex: "2",maxLength:150}} className="txtbox"
	   value={this.state.cm_title}
                          /></p>
 
 </li>
		 )}
		  
		 {this.state.isdisplay===true && ( 

<li>  
		 <p><span className="validation">*</span> Title</p>
		 
		<p>
		<TextField name="cm_title" 
	   onChange={this.myChangeHandler} 
	   fullWidth 		 	 inputProps={{tabIndex: "2",maxLength:150}} className="txtbox"
	   value={this.state.cm_title}
                          /></p>
 
 </li>
		 )}
 
  {this.state.isdisplay===true && ( 
 <li>  
		 <p><span className="validation">*</span> Youtube Link</p>
		 
		<p>
		<TextField name="cm_youtubevediolink" 
	   onChange={this.myChangeHandler} 
	   fullWidth 	 inputProps={{tabIndex: "3",maxLength:150}} className="txtbox"
	   value={this.state.cm_youtubevediolink}
                          /></p>
 
 </li>

  )}
  
   {this.state.iscontent===true && ( 

 <li>
 
	 <p> Content: </p> <p > 
		  
	 <TextField name="cm_content" 
	   onChange={this.myChangeHandler} 
	   fullWidth
	   multiline
          rows={4}
	   value={this.state.cm_content}
			 
			  
			  inputProps={{tabIndex: "4"}} 
	   InputLabelProps={{ shrink: true }}
                          />
		  </p>
   </li>)}
		</ul>				


   <p className="aligncentr"> 
		  <Button variant="contained" className="frmSecondarybtn" onClick={this.handleSubmit}>
   Submit
</Button></p>
		 

</div>
 
 </React.Fragment>
  );
  }
	  
	  
 
	  
	  
	  
	   }